import axios from 'axios'
import process from './default.js'
import cookies from 'vue-cookies'
// 创建axios 实例
console.log(process)
const service = axios.create({
	baseURL: process.dev, // api的base_url
	timeout: 10000, // 请求超时时间
})

// request 拦截器
service.interceptors.request.use(
	config => {
		// 这里可以自定义一些config 配置
		var token = cookies.get('PHPSESSID')
		config.data.session=`${token}`
		console.log(token)
		return config
	},
	error => {
		//  这里处理一些请求出错的情况

		console.log(error)
		Promise.reject(error)
	}
)

// response 拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		console.log(response)
		// 这里处理一些response 正常放回时的逻辑

		return res
	},
	error => {
		// 这里处理一些response 出错时的逻辑

		return Promise.reject(error)
	}
)

export default service
